import React from "react";

// =====================================================================
//  OemStar — shared gold star mark for OEM / MIDAS-readiness surfaces (DR-1)
//  Path data from Paper artboard v2-1. The two gold fills used across the
//  feature are per-artboard, so `fill` is caller-supplied (default = the
//  OEM ribbon gold #B98A1F).
// =====================================================================

interface OemStarProps {
  size?: number;
  fill?: string;
}

const OemStar: React.FC<OemStarProps> = ({ size = 12, fill = "#B98A1F" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M12 2l2.6 5.9 6.4.6-4.8 4.3 1.4 6.2-5.6-3.3-5.6 3.3 1.4-6.2L3 8.5l6.4-.6z"
      fill={fill}
    />
  </svg>
);

export default OemStar;
